"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BuryingPointType = exports.BuryingPointSource = void 0;
var _crmApi = require("@ys/crm-api");
var BuryingPointType;
(function (BuryingPointType) {
  /** 登录 */
  BuryingPointType["Login"] = "0";
  /** 广场 */
  BuryingPointType["Square"] = "1";
})(BuryingPointType || (exports.BuryingPointType = BuryingPointType = {}));
var BuryingPointSource;
(function (BuryingPointSource) {
  /** 企业微信  */
  BuryingPointSource["Wecom"] = "wecom";
  /** PC */
  BuryingPointSource["Pc"] = "pc";
})(BuryingPointSource || (exports.BuryingPointSource = BuryingPointSource = {}));
class BuryingPoint {
  constructor(option) {
    this.handleVisibilityChange = () => {
      this.evaluatePolling();
    };
    this.handleWindowFocus = () => {
      this.evaluatePolling();
    };
    this.handleWindowBlur = () => {
      this.evaluatePolling();
    };
    this.timer = null;
    this.stopTimer = null;
    const {
      interval = 10 * 1000,
      type,
      source
    } = option;
    this.interval = interval;
    this.type = type;
    this.source = source;
    this.addEventListeners();
    this.evaluatePolling();
  }
  addEventListeners() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    window.addEventListener('focus', this.handleWindowFocus);
    window.addEventListener('blur', this.handleWindowBlur);
  }
  removeEventListeners() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener('focus', this.handleWindowFocus);
    window.removeEventListener('blur', this.handleWindowBlur);
  }
  evaluatePolling() {
    const isActive = document.visibilityState === 'visible' && document.hasFocus();
    isActive ? this.start() : this.stop();
  }
  start() {
    if (this.stopTimer) {
      clearTimeout(this.stopTimer);
      this.stopTimer = null;
    }
    if (!this.timer) {
      this.timer = setInterval(() => {
        _crmApi.YcUserService.postUserOperateCollect({
          body: {
            operateType: this.type,
            source: this.source
          }
        });
      }, this.interval);
    }
  }
  stop() {
    if (this.stopTimer) {
      return;
    }
    this.stopTimer = setTimeout(() => {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.stopTimer = null;
    }, 5 * 1000);
  }
  destroy() {
    this.stop();
    this.removeEventListeners();
  }
}
exports.default = BuryingPoint;